export default __webpack_public_path__ + "efc1fc4474c3489737029cd840d731d6.svg";